import { SVGProps } from 'react';

const Bus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 6v6m7-6v6M2 12h19.6M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2s-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3m13 0a2 2 0 1 1-4 0m4 0a2 2 0 1 0-4 0m-9 0a2 2 0 1 0 4 0m-4 0a2 2 0 1 1 4 0m0 0h5"
    />
  </svg>
);
export default Bus;
